import * as types from "./../types";

// const ekycData = {
//   ekycaddress: []
// };
const initState = {
  kycMode:"",
  error: null,
  eKycRedirectEncrpData:"",
  eKycRedirectDecrypData:"",
 // ekycTelcoFlag:"",
 // ekycTelcoReason:"",
  telcoReqBancaFLag:"",
  telcoReason: "",
  stpReKyc:"",
  gender: "",
  address: [],
  document: [],
  addressSplitStatus:"",
  earlyCreditDecPartner:null
};

const EkycReducer = (state = initState, action) => {
  switch (action.type) {
    case types.SAVE_EKYC_DATA:
        return {
          ...state,
          address: (action.payload?.kycValid && action.payload?.kycValid ==="Y") ? action.payload?.address : "",
          gender: action.payload?.gender,
          error: action.payload?.error,
          document: action.payload?.document,
          addressConfirmationRequired: action.payload?.addressConfirmationRequired,
          telcoRequiredFlag: action.payload?.telcoRequiredFlag,
          telcoReqBancaFLag: action.payload?.telcoFlag,
          telcoReason: action.payload?.telcoReason,
          addressMatchFlag: action.payload?.addressMatchFlag,
          addressSplitStatus: action.payload?.address?.[0]?.addressSplitStatus,
          kycCompleted: action.payload?.kycCompleted,
          kycValid: action.payload?.kycValid,
        };
    case types.SAVE_EKYC_REDIRECT_ENCRYPTED_DATA:
      return {
        ...state,
        eKycRedirectEncrpData: action.payload?.enc
      };     
    case types.SAVE_EKYC_REDIRECT_DECRYPTED_DATA:
      return {
        ...state,
        eKycRedirectDecrypData: { ...action.payload?.dec.data, hsToken: action.payload?.dec?.hsToken }
      };     
    case types.SAVE_TELCO_FLAGS_FOR_EKYC_JOURNEY:   
        return {
        ...state,
       // ekycTelcoFlag: action.payload?.ekycJourneytelcoFLag,
       // ekycTelcoReason: action.payload?.ekycJourneytelcoReason
          telcoReqBancaFLag: action.payload?.ekycJourneytelcoFLag,
          telcoReason: action.payload?.ekycJourneytelcoReason,
      };  
    case types.SAVE_REKYC_FLAG:   
        return {
        ...state,
        stpReKyc: action.payload?.stpReKyc
      }; 
    case types.SAVE_EARLY_CREDIT_FLAG:      
      return {
        ...state,
        earlyCreditDecPartner : action.payload
      };
      
    default:
      return state;
  }
};

export default EkycReducer;